import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { TagService } from '../../../../shared/services/apis/produto/tag.service';
import { TagRequest } from '../../../../shared/services/requests/produto/tag.request';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { UiTagComponent } from '../../../../shared/components/ui-tag/ui-tag.component';

@Component({
  selector: 'app-tag-cadastro',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    LoadingBoxComponent,
    FooterActionComponent,
    MatProgressSpinnerModule,
    HeaderComponent,
    UiTagComponent,
  ],
  templateUrl: './tag-cadastro.component.html',
  styleUrl: './tag-cadastro.component.css',
})
export class TagCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Cadastros;

  public form: FormGroup;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isEdicao: boolean = false;
  public idTag: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private tagService: TagService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.createForm();

    this.route.params.subscribe(params => {
      if (params['idTag']) {
        this.idTag = +params['idTag'];
        this.isEdicao = true;
        this.carregarTag();
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      nome: ['', Validators.required],
      cor: ['#C0C0C0', Validators.required],
    });
  }

  public onColorChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const color = input.value;
    if (color && color.startsWith('#') && (color.length === 4 || color.length === 7)) {
      this.form.get('cor')?.setValue(color, { emitEvent: false });
    }
  }

  private carregarTag(): void {
    this.isLoading = true;
    this.tagService.getById(this.idTag).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Erro ao carregar tag.', AlertType.error);
          this.voltar();
          return;
        }

        if (res.listaTags && res.listaTags.length > 0) {
          const tag = res.listaTags[0];
          this.form.patchValue({
            nome: tag.nome,
            cor: tag.cor,
          });
        } else if (res.tag) {
          this.form.patchValue({
            nome: res.tag.nome,
            cor: res.tag.cor,
          });
        }
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao carregar a tag.', AlertType.error);
        console.error(err);
        this.voltar();
      },
    });
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.alertService.show('Atenção', 'Não é possível salvar uma tag sem descrição.', AlertType.warning);
      return;
    }

    this.isSaving = true;
    const request: TagRequest = this.form.value;

    if (this.isEdicao) {
      this.tagService.update(this.idTag, request).subscribe({
        next: res => {
          this.tratarRetornoSalvar(res);
        },
        error: err => {
          console.error('Update error', err);
          this.tratarErroSalvar(err);
        },
      });
    } else {
      this.tagService.create(request).subscribe({
        next: res => {
          this.tratarRetornoSalvar(res);
        },
        error: err => {
          console.error('Create error', err);
          this.tratarErroSalvar(err);
        },
      });
    }
  }

  private tratarRetornoSalvar(res: any): void {
    this.isSaving = false;
    if (res.isError) {
      const msg =
        res.errorDescription && res.errorDescription.toLowerCase().includes('duplicate')
          ? 'Já existe uma tag com este nome informado.'
          : res.errorDescription || 'Erro ao salvar tag.';

      this.alertService.show('Atenção', msg, AlertType.warning);
    } else {
      this.alertService.show('Sucesso', 'Tag salva com sucesso.', AlertType.success);
      this.voltar();
    }
  }

  private tratarErroSalvar(err: any): void {
    this.isSaving = false;
    this.alertService.show('Erro', 'Ocorreu um erro ao salvar.', AlertType.error);
    console.error(err);
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/cadastros/tags']);
  }
}
